import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { Title } from '@angular/platform-browser';
import { DialogService } from 'src/app/_services/dialog.service';
import { CouponService } from '../_ecomservices/coupon.service';
import { PageService } from '../_ecomservices/page.service';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.css']
})
export class PagesComponent implements OnInit {

  displayedColumns = ['ID', 'Title', 'Slug', 'Action'];
  dataSource: MatTableDataSource<any>;

  constructor(public couponService: CouponService,
    public pageService: PageService,
    private dialog: MatDialog,
    private titleService: Title,
    private loading: LoadingService,
    private notificationService: NotificationService,
    public dialogService: DialogService,) { }

  ngOnInit() {
    this.titleService.setTitle('Web Pages');
    this.get_all_pages();
  }

  get_all_pages() {
    var result = this.pageService.get_all_pages().subscribe(data => {
      //console.log(data);
      if (data['status']) {
        this.dataSource = new MatTableDataSource<any>(data['pages']);
      }
    });
  }

  // onCreateCoupon() {
  //   const matDialogConfig = new MatDialogConfig();
  //   matDialogConfig.disableClose = true;
  //   matDialogConfig.autoFocus = true;
  //   matDialogConfig.width = "40%";
  //   matDialogConfig.position = { top: '10px' }
  //   this.dialog.open(CouponCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
  //     this.get_all_coupons();
  //   });
  // }

  onDelete(pageId: any) {
    this.dialogService.openConfirmDialog('Are you sure to delete this page ?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.loading.spin$.next(true);
          this.pageService.delete_page(pageId).subscribe(data => {
            //console.log(data);
            if (data['status']) {
              this.notificationService.success(data['message']);
              this.get_all_pages();
              this.loading.spin$.next(false);
            }
            else {
              this.notificationService.error('Page could not be deleted, Try Again!');
              this.loading.spin$.next(false);
            }
          });
        }
      });
  }

  onCreatePage() {
    this.pageService.initializeFormGroup();
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '10px' };
    this.dialog.open(PageCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.get_all_pages();
    });
  }

  onEdit(rowData: any) {
    this.pageService.populateForm(rowData);
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '10px' };
    this.dialog.open(PageCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.get_all_pages();
    });
  }

  togglePageStatusChange(event: any, pageId: any) {
    let checked = event.checked;
    let status = checked ? 1 : 0;
    this.pageService.update_page_status(pageId, status).subscribe(data => {
      console.log(data);
    });
  }


}






/* Create Page */
@Component({
  selector: 'create-page-dialog',
  templateUrl: 'create-page-dialog.html',
})
export class PageCreateComponent {


  constructor(
    private dialogRef: MatDialogRef<PagesComponent>,
    public pageService: PageService,
    private loading: LoadingService,
    private notificationService: NotificationService,
  ) {
  }


  onPageFormSubmit(formData: any) {
    if (this.pageService.page_form.valid) {
      this.loading.spin$.next(true);
      if (!this.pageService.page_form.controls['id'].value) {
        // Insert Data
        this.pageService.create_page(formData).subscribe(data => {
          //console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.pageService.page_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error('Page could not be created, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      }
      else {
        // Update Data
        //console.log('data updated');
        this.pageService.update_page(formData).subscribe(data => {
          console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.pageService.page_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            console.log('error');
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }
    }
  }


  onClose() {
    // console.log('Close');
    this.pageService.page_form.reset();
    this.dialogRef.close();
  }

}


